<template>
    <v-container class="content-container">
        <v-row>
            <v-col>
                <!-- Panel title -->
                <div class="page-heading">
                    {{ $t(`ZakljucekPogodbe.Zakljucek.Subtitle`) }}
                </div>

                <!-- Alert error -->
                <div class="notification notification--warning"
                    v-if="dokoncanjePogodbeStore.FormState.ErrorText.length > 0 ? true : false">
                    {{ dokoncanjePogodbeStore.FormState.ErrorText }}
                </div>

                <!-- Alert success -->
                <div class="notification notification--success"
                    v-if="dokoncanjePogodbeStore.FormState.SuccessText.length > 0 ? true : false">
                    {{ dokoncanjePogodbeStore.FormState.SuccessText }}
                </div>

                <!-- Btns -->
                <div class="mt-8 mb-8 d-flex align-center ga-4">
                    <v-btn @click="appStore.BackToDashboard()" flat class="btn btn--primary-fill">
                        {{ $t(`ZakljucekPogodbe.Btn.Close`) }}
                    </v-btn>
                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
    import { useAppStore } from "@appstore/store";

    const appStore = useAppStore();
    const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();

    dokoncanjePogodbeStore.Steps.Pogodba.disabled = true;
    dokoncanjePogodbeStore.Steps.Dokumentacija.disabled = true;
    dokoncanjePogodbeStore.Steps.Identifikacija.disabled = true;
    dokoncanjePogodbeStore.Steps.Zakljucek.disabled = false;
    dokoncanjePogodbeStore.Steps.Pogodba.done = true;
    dokoncanjePogodbeStore.Steps.Identifikacija.done = true;
    dokoncanjePogodbeStore.Steps.Dokumentacija.done = true;
    dokoncanjePogodbeStore.Steps.Zakljucek.done = true;

</script>